/*
 * Ryan O'Dowd
 * 2022-07-22
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({colors, globalScale, fonts}) => {
  const title = {
    fontFamily: fonts.primaryBold,
    fontSize: globalScale * 18,
    color: colors.accent,
    marginBottom: 0,
  };

  const lightBackground = {
    color: colors.accentDark,
  };

  return {
    heroText: {
      color: colors.white,
      marginBottom: 16,
    },
    bulletPoint: {
      display: 'flex',
      marginBottom: 16,
      flexDirection: 'column',
      color: colors.white,
    },
    title,
    lightBackground,
    lightBackgroundText: {
      color: colors.dialogText,
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    sideBySide: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 16,
    },
    section: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      minWidth: globalScale * 250,
    },
    contactHeader: {
      ...title,
      ...lightBackground,
    },
    contactText: {
      fontSize: '0.90em',
      marginTop: 0,
    },

    organizationCard: {
      minWidth: 100,
      maxWidth: 300,
      backgroundColor: colors.primaryExtraDark,
    },
    cardMedia: {
      paddingTop: 16,
      paddingLeft: 16,
      paddingRight: 16,
      width: '100%',
      height: 140,
      backgroundColor: colors.primaryExtraDark,
    },
    cardContent: {
      color: colors.white,
      backgroundColor: colors.primaryExtraDark,
      paddingTop: 4,
    },
    organizationName: {
      fontSize: globalScale * 18,
      color: colors.white,
      fontFamily: fonts.primaryBold,
      marginBottom: globalScale * 4,
    },
    organizationText: {
      color: colors.white,
    },

    contactAndDownloadWrapper: {
      display: 'flex',
      flexDirection: window.innerWidth > globals.mediaQuerySizes.sm ? 'row' : 'column', // @TODO: not responsive...listen to changes to width or use mui grid
      width: '100%',
      justifyContent: 'space-between',
    },
    contactWrapper: { // @TODO: abstract with LandingPage
      minWidth: '50%',
    },
    downloadCtaWrapper: { // @TODO: abstract with LandingPage
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
};

export default getStyles;
